import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRoute, lazyRouteNamed } from '../lazy-route';

export const documentsRoutes: RouteObject[] = [
  {
    path: RoutesList.DOCUMENT_SIGNATURE,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRouteNamed(
          () => import('../../pages/document-signing/document-signature-page'),
          'DocumentSignaturePage',
        ),
      },
    ],
  },
  {
    path: RoutesList.DOCUMENTS,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRoute(() => import('../../pages/documents-archive/DocumentsArchivePage')),
      },
    ],
  },
];
